import { FC } from 'react';
import Link from 'next/link';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import styles from './Footer.module.css';
import { getSolanaNetwork } from '../utils/getSolanaNetwork';

const Footer: FC = () => {
  const network = getSolanaNetwork();
  const networkName = network === 'devnet' ? 'Solana Devnet' : network === 'testnet' ? 'Solana Testnet' : 'Solana Mainnet';
  const { showSettings } = useCookieConsent();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.links}>
          <Link href="/about" className={styles.link}>
            About
          </Link>
          <span className={styles.separator}>•</span>
          <Link href="/tos" className={styles.link}>
            Terms of Service
          </Link>
          <span className={styles.separator}>•</span>
          <a href="/privacy" className={styles.link} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <span className={styles.separator}>|</span>
          <a href="/disclaimer" className={styles.link} target="_blank" rel="noopener noreferrer">Disclaimer</a>
          <span className={styles.separator}>•</span>
          <a href="mailto:main@soulminter.io" className={styles.link}>
            main@soulminter.io
          </a>
          <span className={styles.separator}>•</span>
          <a href="https://x.com/soulminter_io" target="_blank" rel="noopener noreferrer" className={styles.link}>
            X (Twitter)
          </a>
          <span className={styles.separator}>•</span>
          <a href="https://discord.com/users/soulminter_95345" target="_blank" rel="noopener noreferrer" className={styles.link}>
            Discord
          </a>
          <span className={styles.separator}>•</span>
          <button onClick={showSettings} className={`${styles.link} ${styles.cookieSettings}`}>
            🍪 Cookie Settings
          </button>
        </div>
        <div className={styles.network}>
          <span className={styles.networkLabel}>Network:</span>
          <span className={styles.networkValue}>{networkName}</span>
        </div>
        <div className={styles.address}>
          HU, 9400 Sopron, Gyóni Géza utca 4 1 em. 4 a. • <a href="tel:+437763101939" className={styles.link}>+43 77 63101939</a>
        </div>
        <div className={styles.disclaimer}>
          SoulMinter is an independent software tool. We are not affiliated with,
          partnered with, sponsored by, or endorsed by Solana, any wallet provider,
          or any other third party. All trademarks are the property of their
          respective owners.
        </div>
      </div>
    </footer>
  );
};

export default Footer; 